import { CarouselItem } from '../../models/item';
import { RrAreaProfile } from '../../models/rr_profile';

export class MyCatalogModal {
    public isLogin: boolean;
    public userId: string;
    public userTracking: string;
    public userSegments: string[];
    public shouldDisplayRecommend: boolean;
    // RRエリア
    public rrAreaProfileMyCatalogModal: RrAreaProfile;
  
    constructor() {
      this.isLogin = MyCatalogModal.stringToBoolean((document.getElementById('my_catalog_rr_isLogin') as HTMLInputElement).value);
      this.userId = (document.getElementById('my_catalog_rr_userId') as HTMLInputElement).value;
      this.userTracking = (document.getElementById('my_catalog_rr_userTracking') as HTMLInputElement).value;
      this.userSegments = (document.getElementById('my_catalog_rr_userSegments') as HTMLInputElement).value.split(",");
      this.shouldDisplayRecommend = MyCatalogModal.stringToBoolean((document.getElementById('my_catalog_rr_shouldDisplayRecommend') as HTMLInputElement).value);

      this.rrAreaProfileMyCatalogModal = {
        placementName: 'recomRR_myCataModal_01',
        displayCount: 30,
        rrAreaItems: [],
        rrAreaTitle: '',
        perView: 4
      };
    }
    
    public setRrAreaDataMyCatalogModal(
        carouselItemList: CarouselItem[],
        rrAreaTitle: string
      ): void {
        const rrArea = this.rrAreaProfileMyCatalogModal

        rrArea.rrAreaItems = carouselItemList;
        rrArea.rrAreaTitle = rrAreaTitle;
      }

    static stringToBoolean(value: string | null | undefined): boolean {
        // null、undefined は false
        if (!value) {
            return false;
        }
        // 小文字にして判定
        return value.toLowerCase() === 'true';
    }
}